import { useEffect, useMemo, useState } from 'react';

export interface MetricChartTheme {
  axis: string;
  grid: string;
  tooltipBackground: string;
  tooltipBorder: string;
  tooltipText: string;
  colors: {
    blue: string;
    green: string;
    amber: string;
    red: string;
    indigo: string;
    slate: string;
  };
}

const lightTheme: MetricChartTheme = {
  axis: '#475569',
  grid: '#e2e8f0',
  tooltipBackground: '#ffffff',
  tooltipBorder: '#cbd5e1',
  tooltipText: '#0f172a',
  colors: {
    blue: '#2563eb',
    green: '#0d9488',
    amber: '#d97706',
    red: '#dc2626',
    indigo: '#4f46e5',
    slate: '#475569',
  },
};

const darkTheme: MetricChartTheme = {
  axis: '#cbd5e1',
  grid: '#334155',
  tooltipBackground: '#0f172a',
  tooltipBorder: '#334155',
  tooltipText: '#f8fafc',
  colors: {
    blue: '#60a5fa',
    green: '#2dd4bf',
    amber: '#fbbf24',
    red: '#f87171',
    indigo: '#818cf8',
    slate: '#94a3b8',
  },
};

function isDarkTheme() {
  return document.documentElement.classList.contains('dark');
}

export function useMetricChartTheme() {
  const [isDark, setIsDark] = useState(() => isDarkTheme());

  useEffect(() => {
    const observer = new MutationObserver(() => setIsDark(isDarkTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return useMemo(() => (isDark ? darkTheme : lightTheme), [isDark]);
}
